module.exports = __webpack_public_path__ + "img/nodata.61792c57.png";